/* eslint-disable */
<template>
  <div class="specialist-search">
    <AdminNavigation v-if="user.type >= 3" ref="navigation" indexProps="5"/>
    <Navigation v-else indexProps="1"/>
    <div class="top-panel no-sub-title">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Search for Specialist Availability to book an Appointment</h1></div>
      </div>
    </div>
    <div class="panel no-sub-title">
      <AdminBookingsMenu v-if="user.type >= 3" :key="0" :indexProps="0"/>
      <SpecialistMenu v-else-if="user.type !== 1" indexProps="0"/>
      <div class="content" :style="{width: user.type === 1 ? '90%' : '80%', left: user.type === 1 ? '0' : '220px'}"
           v-if="showContent">
        <div v-if="showCaseInfo">
          <span class="text-bold">Examinee: </span> {{ singleCase.ClaimantFullName }} <span
            class="text-bold"> D.O.B: </span> {{ formatDate(singleCase.DateofBirth) }}
          <span class="text-bold"> Referral Type: </span> {{ booking.ClaimType.ClaimTypeName }}
        </div>

        <div class="box box-search-result" v-if="showSearchResult">
          <div class="box-heading">
            <div>Search Results</div>
            <ProfileReadMoreModal ref="profileReadMoreModal"/>
          </div>
          <div class="box-body">
            <div class="box-row search-value">
              <span class="text-bold pr-1">Searching for: </span>
              {{getBookingType()}},
              <span class="text-bold padding-left-10 pr-1">
              {{ getSearchOption(searchResultOption.specialtyId, searchResultOption.specialistId) }}
                </span>
              <span class="text-bold padding-left-10 pr-1"
                    v-if="getNeedAvailability(this.searchResultOption.bookingTypeID)"> Date Range: </span>
              {{ displayDateRange() }}
            </div>

            <!-- Display search result when user search by Specialty -->
            <div class="search-with-specialty search-without-specialist-specialty"
                 v-if="showCalendar && !showNoSearchResult">
              <div v-if="!filterMode && !showWorkCover && !showOnlyAvailable"
                   class="ms-4  d-flex align-items-center"><h6>Displaying all related results, use the ‘Show Only’
                filters to narrow down your search</h6>
                <el-button v-if="selectedId" size="small" type="info" class="ms-4" @click="onClickShowAll">Show All
                </el-button>
              </div>
              <div v-if="filterMode === 'person' && noFaceToFaceMsg" class="ms-4 d-flex align-items-center"><h6>No
                availability is found to match your criteria, either search again, select an alternate calendar or
                filter</h6>
                <el-button size="small" type="info" class="ms-4" @click="onClickShowAll">Show All</el-button>
              </div>
              <div v-if="(!filterMode && (showOnlyAvailable || showWorkCover) && user.type >= 3) || (!filterMode && selectedId && user.type < 3)"
                   class="ms-4 d-flex align-items-center">
                <el-button size="small" type="info" class="ms-4" @click="onClickShowAll">Show All</el-button>
              </div>
              <div class="d-flex flex-wrap mt-2" style="padding: 0 20px">
                <div class="search-result search-all"
                     v-for="(item, index) in availabilities.specialist" :key="item.id"
                     v-show="filteredList.findIndex(f => f.specialistId === item.specialists.SpecialistID) > -1"
                     :class="{'selected' : selectedId === item.specialistId}">
                  <div class="box-col h-100">
                    <div class="button center-title d-flex flex-column h-100 justify-content-around">
                      <el-tooltip :content="item.specialists.Qualifications ? item.specialists.Qualifications.map(item => item.QualificationName).join(',') : ''">
                        <div class="name small" style="font-size: 12px">
                          {{ item.specialists.fullName }}
                        </div>
                      </el-tooltip>
                      <v-btn v-if="availabilities.specialist.length !== 1" class="book small" dark
                             @click="tapViewCalendar(item.specialists.SpecialistID, item.specialists.fullName)">
                        {{ isBookingWithoutAvailability ? "Book" : "View Calendar" }}
                      </v-btn>
                      <v-btn @click="tapReadMore(item.specialists.SpecialistID)" class="book small white-button"
                             data-placement="right"
                             data-toggle="tooltip" title="View Profile">View Profile
                      </v-btn>
                    </div>
                  </div>
                  <div v-if="item.specialists.profileThumbnail">
                    <div class="rounded-image smaller-rounded-image m-t-0 m-t-b">
                      <div class="profile-image-content"><img :src="item.specialists.profileThumbnail"/></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="rounded-image smaller-rounded-image m-t-0 m-t-b">
                      <div class="profile-image-content notice-background"><s
                          class="text-initials small">{{ getInitials(item.specialists) }}</s></div>
                    </div>
                  </div>
                </div>
              </div>
              <el-radio-group v-if="searchResultOption.bookingTypeID !== 19" class="w-100 d-flex justify-content-around mt-2" v-model="filterMode">
                <el-checkbox v-model="showOnlyAvailable" @change="onChangeFullyBooked"
                             class="default-checkbox">Hide Fully Booked
                </el-checkbox>
                <el-checkbox v-model="showWorkCover" @change="onChangeWorkCover" v-if="user.type >= 3"
                             class="default-checkbox">Show WorkCover
                </el-checkbox>
              </el-radio-group>
              <div class="box-body">
                <div class="pl-2 ml-8 mt-2 mb-2" v-if="searchResultOption.specialtyId && searchResultOption.specialtyId.length > 0 && dataSource && dataSource.length > 0 && user.type <= 2">
                  <strong>Please Note: </strong>
                  <span>We have other Medical Experts who may provide other appointments on request. Please connect with us via our Live Chat, or call us on 1300 100 733 if you'd like to know more</span>
                </div>
                <div v-if="searchResultOption.bookingTypeID === 17" class="ml-3">Please select the 1st appointment for the IME Plus booking:</div>
                <div>
                  <ClientHorizontalCalendar
                      :calendarDateProps="getYear()"
                      @showNoFaceToFace="showNoFaceToFace"
                      :dataSourceProps="dataSource"
                      :mode="filterMode"
                      :indexKey="1"
                      :showOnlyAvailable="showOnlyAvailable"
                      :showWorkCover="showWorkCover"
                      :location="searchResultOption.regionId"
                      :displayOnly="isDisplayOnly"
                      :hideMonthProps="searchOption"
                      :key="calendarKey"
                      :bookingType="searchResultOption.bookingTypeID"
                      :state="searchResultOption.StateID ? searchResultOption.StateID.replace('s', '') : null"
                      :region="searchResultOption.regionId ? searchResultOption.regionId.replace('r', '') : null"
                      ref="clientHorizontalCalendar"
                      :sync="true"
                      :calendarIndex="1"
                      :imeSelected="curInfo ? curInfo.item.AvailabilityID : null"
                  />
                </div>
                <div v-if="searchResultOption.bookingTypeID === 17">
                  <div class="ml-3" v-if="curInfo">
                    You have picked 1st appointment: {{curInfo.item.AvailabilityDate + ' ' + curInfo.item.StartTime}}
                    <el-button size="small" type="info" class="ms-4" @click="curInfo = null">Reset</el-button>
                  </div>
                  <div class="ml-3">Please select the Occupational Therapist availability for the IME Plus booking:</div>
                  <ClientHorizontalCalendar
                      :bookingType="searchResultOption.bookingTypeID"
                      :calendarDateProps="getYear()"
                      @showNoFaceToFace="showNoFaceToFace"
                      :dataSourceProps="additionalAvailabilities.items"
                      :mode="filterMode"
                      :showOnlyAvailable="showOnlyAvailable"
                      :showWorkCover="showWorkCover"
                      :location="searchResultOption.regionId"
                      :displayOnly="isDisplayOnly"
                      :hideMonthProps="searchOption"
                      :key="calendarKey1"
                      :calendarIndex="2"
                      :state="searchResultOption.StateID ? searchResultOption.StateID.replace('s', '') : null"
                      :region="searchResultOption.regionId ? searchResultOption.regionId.replace('r', '') : null"
                      ref="clientHorizontalCalendar2"
                      :sync="true"
                      :imeSelected="curInfo ? curInfo.item.AvailabilityID : null"
                  />
                </div>
                <div>
                  <div v-if="availabilities.specialist && availabilities.specialist.length > 0" class="p-2">
                    <b>Specialists: </b>
                    <span v-for="(result, index) in availabilities.specialist" :key="index">
                      {{ result.specialists.fullName }} ({{ result.specialists.count }})
                      <span v-if="index < availabilities.specialist.length - 1">, </span>
                    </span>
                  </div>
                  <div v-else class="p-2">
                    <p>No Specialist found.</p>
                  </div>
                </div>
              </div>

            </div>
            <!-- END -->

            <div class="">
              <div class="box-row" v-if="showNoSearchResult">
                <div class="box-col w-100 pt-5 pb-5">
                  <div class="w-100 justify-content-between booking-header-item">
                    <h5 class="mt-0">
                      <div>No results found to match your search.</div>
                      <div>Please adjust the search criteria below and search again, or Submit a Request to tell us what you need, and we'll do the hard work for you.</div>
                    </h5>
                    <div class="d-flex flex-column justify-content-between">
                      <v-btn @click="tapSubmitRequest()" class="submit-request" dark>Submit Request</v-btn>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="showSpecialistAvailable">
              <div class="box-row" v-if="showNoSearchResultForSpecialist">
                <div class="box-col" style="width: 100%; padding-top: 15px; padding-bottom: 45px;">
                  <div class="w-100 justify-content-between booking-header-item">
                    <h3 class="mt-0" style="line-height: 1">
                      <p>No results were found to match your search.</p>
                      <p class="mt-2">Please either search again, or tell us what you need and we’ll do the hard work
                        for you.
                        <v-btn class="book ps-1 pe-1 ms-2" dark @click="tapSubmitRequest(specialist.id)">Submit
                          Request
                        </v-btn>
                      </p>
                    </h3>
                    <!-- <v-btn @click="tapSubmitRequest()" class="submit-request" dark>Submit Request</v-btn> -->
                  </div>
                </div>
              </div>
              <h2 v-if="showNoSearchResultForSpecialist" class="padding-left-20">However we have displayed available
                dates for {{ specialist.fullName }} in other locations</h2>
              <h2 v-else class="padding-left-20">Available dates for {{ specialist.fullName }}</h2>
              <div class="search-result">
                <div class="box-col" v-if="specialist.profileThumbnail">
                  <div class="rounded-image smaller-rounded-image m-t-0 m-t-b">
                    <div class="profile-image-content"><img :src="specialist.profileThumbnail"/></div>
                  </div>
                </div>
                <div class="box-col" v-else>
                  <div class="rounded-image smaller-rounded-image m-t-0 m-t-b">
                    <div class="profile-image-content notice-background"><s
                        class="text-initials small">{{ getInitials(specialist) }}</s></div>
                  </div>
                </div>
                <div class="box-col w-100">
                  <div class="name small" :title="specialist.Qualifications ? specialist.Qualifications.map(item => item.QualificationName).join(',') : ''">
                    {{ specialist.fullName }}
                    <img class="long-text" data-placement="right" data-toggle="tooltip"
                         title="Fly In Fly Out Specialist" v-if="specialist.requiresTravel"
                         src="@/assets/images/travel_black_circle_icon.svg"/>
                  </div>
                  <div class="sub-title small pt-1">
                    {{specialist.Qualifications ? specialist.Qualifications.map(item => item.QualificationName).join(',') : ''}}
                    <img class="long-text" data-placement="right" data-toggle="tooltip"
                         title="Assessment can also be performed via video link"
                         v-if="specialist.videoLinkAvailable == 2" src="@/assets/images/video_icon_with_circle.svg"/>
                  </div>
                  <div class="">
                    <div class="is-icon right-float-element" @click="tapReadMore(specialist.id)">
                      <img class="long-text" data-placement="right" data-toggle="tooltip" title="View Profile"
                           src="@/assets/images/view_booking.svg"/>
                    </div>
                  </div>
                </div>
              </div>
              <el-radio-group v-if="searchResultOption.bookingTypeID !== 19" v-model="filterMode" class="w-100 d-flex justify-content-around mt-2">
                <el-checkbox v-model="showOnlyAvailable" @change="onChangeFullyBooked" v-if="user.type >= 3"
                             class="default-checkbox">Hide Fully Booked
                </el-checkbox>
                <el-checkbox v-model="showWorkCover" @change="onChangeWorkCover" v-if="user.type >= 3"
                             class="default-checkbox">Show WorkCover
                </el-checkbox>
              </el-radio-group>
              <ClientHorizontalCalendar
                  :bookingType="searchResultOption.bookingTypeID"
                  :calendarDateProps="getYear()"
                  :dataSourceProps="dataSource"
                  @showNoFaceToFace="showNoFaceToFace"
                  :hideMonthProps="searchOption"
                  :showOnlyAvailable="showOnlyAvailable"
                  :showWorkCover="showWorkCover"
                  :mode="filterMode"
                  :location="searchResultOption.regionId"
                  :state="searchResultOption.StateID ? searchResultOption.StateID.replace('s', '') : null"
                  :region="searchResultOption.regionId ? searchResultOption.regionId.replace('r', '') : null"
                  :key="calendarKey"
                  ref="clientHorizontalCalendar"
                  :sync="true"
              />
            </div>
          </div>
        </div>

        <div class="box search-details">
          <div class="box-heading">
            <div>Find a Specialist by completing the details below:</div>
          </div>
          <div class="box-body">
            <div class="box-row">
              <div class="box-col box-col-left" :class="isHideSpecialty ? 'disabled-element' : ''">I'm looking for a
              </div>
              <div class="box-col box-col-right">
                <div class="d-flex align-items-center w-100">
                  <el-select placeholder="Select specialty" multiple class="w-50" @change="onChangeSpecialty" filterable
                             clearable :disabled="isHideSpecialty" :class="isHideSpecialty ? 'disabled-element' : ''"
                             v-model="searchOption.specialtyId">
                    <el-option v-for="(specialty, index) in specialties" :key="specialty.id" :value="specialty.id"
                               :label="specialty.name">{{ specialty.name }}
                    </el-option>
                  </el-select>
                  <el-checkbox @change="onChangeCheck" class="ms-2 default-checkbox" v-model="isHideSpecialty">OR, click
                    here if you know which specialist you want
                  </el-checkbox>
                </div>
                <div v-if="hasError && !validateSpecialty" class="text-danger">Specialty is required.</div>
              </div>
            </div>
            <div class="box-row" :class="!isHideSpecialty ? 'disabled-element' : ''">
              <div class="box-col box-col-left">I want an appointment with</div>
              <div class="box-col box-col-right">
                <el-select placeholder="Select specialist" class="w-50" @change="onChangeSpecialist" filterable
                           clearable :disabled="!isHideSpecialty" v-model="searchOption.specialistId">
                  <el-option v-for="(specialist, index) in listSpecialists" :key="specialist.id" :value="specialist.id"
                             :label="specialist.name">{{ specialist.name }}
                  </el-option>
                </el-select>
                <div v-if="hasError && !validateSpecialist" class="text-danger">Specialist is required.</div>
              </div>
            </div>
            <div class="box-row"
                 :disabled="this.disabledBookingType ? true: false"
                 :class="this.disabledBookingType ? 'disabled-element' : ''">
              <div class="box-col box-col-left">Service Type</div>
              <div class="box-col box-col-right">
                <el-select filterable clearable placeholder="Select booking type" popper-class="search-popup-longer"
                           :disabled="this.booking.BookingID != '' || this.disabledBookingType ? true: false"
                           @change="onChangeBookingType" class="w-50" v-model="searchOption.bookingTypeID">
                  <el-option v-for="(bookingType, index) in filteredBookingTypes" :key="index" :value="bookingType.id"
                             :label="bookingType.name">{{ bookingType.name }}
                  </el-option>
                </el-select>
                <div v-if="hasError && !validateBookingType" class="text-danger">Service Type is required.</div>
              </div>
            </div>
            <div
                v-if="!hideOther"
                class="box-row">
              <div class="box-col box-col-left">Examinee Lives in</div>
              <div class="box-col box-col-right">
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    class="w-50"
                    :options="regionLocations"
                    :value="locationValue"
                    @change="changeRegion"
                    :props="{ checkStrictly: true, value: 'id', label: 'label' }"
                    clearable>
                </el-cascader>
                <div v-if="hasError && !validateLocation" class="text-danger">Region / Location is required.</div>
              </div>
            </div>
            <div class="box-row"
                 v-if="showDateRange && !hideOther">
              <div class="box-col box-col-left">I want an assessment between these dates</div>
              <div class="box-col box-col-right">
                <v-md-date-range-picker :start-date="searchOption.startDate" :end-date="searchOption.endDate"
                                        class="w-50" @change="changeDateRange"></v-md-date-range-picker>
                <div v-if="invalidDate" class="text-danger">End Date cannot be before Today</div>
                <div v-if="!validateDateRange && hasError" class="text-danger">Please select date range</div>
              </div>
            </div>

            <div v-if="showDelivery && !hideOther" class="box-row">
              <div class="box-col box-col-left">Delivery Method</div>
              <div class="box-col box-col-right">
                <el-select filterable multiple clearable placeholder="Select delivery method"
                           class="w-50" v-model="searchOption.deliveryMethod">
                  <el-option :value="2" label="Virtual"
                             title="This service will be delivered by videolink only."></el-option>
                  <el-option :value="1" label="In-Person"
                             title="This service will be delivered face to face with the Medical Expert"></el-option>
                </el-select>
                <div v-if="hasError && !validateServiceType" class="text-danger">Delivery method is required.</div>
              </div>
            </div>
            <div v-if="!hideOther" class="box-row">
              <div class="box-col box-col-left">Certifications</div>
              <div class="box-col box-col-right">
                <el-select filterable multiple clearable placeholder="Select certifications"
                           class="w-50" v-model="searchOption.CertificationIDs">
                  <el-option v-for="item in certifications" :key="item.id" :value="item.id" :label="item.name">
                    {{ item.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="box-row item-right">
          <div>
            <v-btn class="submit-request" @click="tapSearch()" dark>Search</v-btn>
          </div>
        </div>
        <br>
        <div class="d-flex justify-content-center">
          <div style="height: fit-content"
               class="w-75 pt-3 pb-3 box-heading-center d-flex justify-content-between align-items-center pl-10 pr-10">
            <div class="display-sub-title">
              <div><b>Not sure what specialist to book or can’t find what your looking for?</b></div>
              <div><b>Submit a Request and we’ll do the hard work for you.</b></div>
            </div>
            <v-btn @click="tapSubmitRequest()" class="submit-request ps-1 pe-1" dark>Submit Request</v-btn>
          </div>
        </div>
        <br>
        <div class="box box-search-history" v-if="this.searchLogs.length > 0">
          <div class="box-heading col-space-between">
            <div>Previous Searches</div>
            <div class="">
              <v-btn class="submit-request" @click="showAllSearchLog" v-if="searchLogs.length <= 5" dark>View All
              </v-btn>
            </div>
          </div>
          <div class="box-body">
            <div class="box-row list-row" :class="searchLogs.length <= 5 ? 'searchlog-height' : ''">
              <div @click="setSearchItem(log)" class="list-row-item is-icon" v-for="(log, index) in searchLogs"
                   :key="index">
                <strong class="mr-1">Searching
                  for: </strong>{{
                  log.SpecialistID ? getSpecialistName(log.Specialist) : log.Qualifications.map(item => item.QualificationName).join(', ')
                }}
                <strong class="mr-1 ml-6">Date
                  Range: </strong>{{ formatDate(log.StartDate) + ' - ' + formatDate(log.EndDate) }}
                <strong v-if="log.State || log.Region" class="mr-1 ml-6">Location: </strong>{{
                  (log.State ? log.State.StateName : '') + (log.Region ? log.Region.RegionName : '')
                }}
                <strong class="mr-3 ml-6">{{ getDeliveryMethod(log) }} </strong>
                <span class="mr-3 ml-6">{{ log.Certifications && log.Certifications.length > 0 ? log.Certifications.map(item => item.CertificationName).join(',') : ''}} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Information about TPD Assist" :visible.sync="tpdList">
      <div class="mt-2" style="word-break: break-word" v-html="tpdList && tpdList.Message">
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelTPDModal">Cancel</el-button>
    <el-button type="primary" @click="confirmTPDModal">OK</el-button>
  </span>
    </el-dialog>
    <Chat v-if="this.user.type < 3"/>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import SpecialistMenu from '@/components/SpecialistMenu'
import AdminNavigation from "@/components/AdminNavigation";
import AdminBookingsMenu from "@/components/AdminBookingsMenu";
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import ProfileReadMoreModal from '@/components/ProfileReadMoreModal'
import ClientHorizontalCalendar from '@/components/ClientHorizontalCalendar'

export default {
  name: 'SearchSpecialist',
  components: {
    Navigation,
    SpecialistMenu,
    AdminNavigation,
    AdminBookingsMenu,
    Header,
    Chat,
    ProfileReadMoreModal,
    ClientHorizontalCalendar,
  },
  data() {
    return {
      tpdList: null,
      locationValue: null,
      redReschedule: false,
      bookingRequest: null,
      showWorkCover: false,
      originalList: [],
      showOnlyAvailable: false,
      filteredList: [],
      filterMode: false,
      hideOther: false,
      calendarKey1: 1,
      searchOption: {
        deliveryMethod: null,
        CertificationIDs: [],
        specialtyId: '',
        specialistId: '',
        locationId: '',
        locationName: '',
        regionId: null,
        radius: '',
        startDate: window.moment().format('YYYY-MM-DD'),
        endDate: window.moment().add(6, 'w').format('YYYY-MM-DD'),
        bookingTypeID: null,
        StateID: null
      },
      searchResultOption: {
        specialtyId: '',
        specialistId: '',
      },
      additionalAvailabilities: {},
      certifications: [],
      clickSpecialty: false,
      clickSpecialist: false,
      clickBookingType: false,
      isHideSpecialty: false,
      showAll: true,
      showDateRange: true,
      showLocation: true,
      hasError: false,
      noFaceToFaceMsg: null,
      checked: false,
      showCaseInfo: false,
      isReschedule: false,
      showNoSearchResult: false,
      showSearchResult: false,
      showAlternative: false,
      showRelatedProf: false,
      showSpecialistAvailable: false,
      showNoSearchResultForSpecialist: false,
      showSpecialist: false,
      isWaitlisted: false,
      showContent: true,
      isDateChange: false,
      invalidDate: false,
      showRadius: true,
      additionalsearch: false,
      isFromCalendar: false,
      isFromSpecialist: false,
      showCalendar: false,
      isBookingWithoutAvailability: false,
      disabledBookingType: false,
      minimumAppointmentLength: '',
      bookingType: '',
      bookingId: '',
      theme: '',
      specialty: '',
      searchRegionId: '',
      bookingTypeId: '',
      showDelivery: false,
      bookingRequestId: '',
      waitlistTime: '',
      clientId: '',
      curInfo: null,
      claimTypes: [],
      specialists: [],
      specialist: [],
      specialties: [],
      listSpecialists: [],
      originalListSpecialists: [],
      regions: [],
      locations: [],
      regionLocations: [],
      searchLogs: [],
      availabilities: [],
      allBookingTypes: [],
      specialistTimes: [],
      allSearchLog: [],
      spLocations: [],
      timeCount: 0,
      booking: utilities.initBooking(),
      singleCase: utilities.initCase(),
      pagination: utilities.initPagination(),
      bookingTypes: [],
      filteredBookingTypes: [],
      selectedId: null,
      searchResult: this.initSearchResult(),
      specialistIds: [],
      isDisplayOnly: '',

      dataSource: [],
      calendarKey: 0,
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    validateBookingType() {
      return this.searchOption.bookingTypeID;
    },
    validateServiceType() {
      if(this.hideOther) {
        return true
      }
      if (utilities.bookingTypeWithDeliveryMethods(this.searchOption.bookingTypeID)) {
        return this.searchOption.deliveryMethod && this.searchOption.deliveryMethod.length > 0;
      }
      return true
    },
    validateDateRange() {
      if(this.hideOther) {
        return true
      }
      return this.searchOption.startDate && this.searchOption.endDate

    },
    validateSpecialist() {
      return !(this.searchOption.specialistId === '' && this.isHideSpecialty);

    },
    validateSpecialty() {
      return !(this.searchOption.specialtyId === '' && !this.isHideSpecialty);

    },
    validateLocation() {
      if(this.hideOther) {
        return true
      }
      return !(this.getNeedAvailability(this.searchOption.bookingTypeID) && !this.searchOption.regionId && !this.searchOption.StateID);
    },
  },

  methods: {
    cancelTPDModal() {
      this.tpdList = null;
      this.availabilities = [];
      this.showCalendar = false
      this.showSearchResult = false
      this.dataSource = []
      this.clearSearch()
    },
    confirmTPDModal() {
      this.tpdList = null;
    },
    getDeliveryMethod(i) {
      const filter = i.DeliveryMethods.map((item) => item.DeliveryMethodID);
      if (filter.length === 0) {
        return ''
      } else if (filter.length === 2) {
        return 'Mixed'
      } else if (filter[0] === 1) {
        return 'In Person'
      } else {
        return 'Virtual'
      }
    },
    getSpecialistName(n) {
      return utilities.getSpecialistFullNameUpper(n)
    },
    async onClickShowAll() {
      this.showWorkCover = false
      this.showOnlyAvailable = false
      this.filterMode = null
      this.searchResult.results = []
      this.filteredList = this.getFilterAvailabilities()
      this.onChangeFullyBooked(true)
    },
    showNoFaceToFace(b, msg) {
      if (b && this.filterMode) this.noFaceToFaceMsg = 'No Face to Face appointments match your search. There are VideoLink appointments available. Click "Show Only VideoLink Assessments" to pick one."'
      else if (b && !this.filterMode && msg) this.noFaceToFaceMsg = msg
      else this.noFaceToFaceMsg = null
    },
    getDuration(specialist) {
      return `${specialist.lastAvailability} ~ ${specialist.nextAvailability}`
    },
    onChangeCheck(e) {
      if (e) this.searchOption.specialtyId = ''
      else this.searchOption.specialistId = ""
    },
    async onChangeWorkCover(e) {
      this.filteredList = this.getFilterAvailabilities()
      if (this.showOnlyAvailable) {
        this.filteredList = this.filteredList.filter(item => item.status !== 'fully booked')
      }
      if (e) {
        this.filteredList = this.filteredList.map(item => {
          const arr = []
          item.Availabilities.forEach(a => {
            const avaArr = []
            if (a.AvailabilityOptions.ShowWorkCover) {
              avaArr.push(a)
            }
            if (avaArr.length > 0) arr.push({...a, Availabilities: avaArr})
          })
          return {
            ...item,
            Availabilities: arr
          }
        })
        this.filteredList = this.filteredList.filter(item => item.Availabilities.length > 0)
      }
      this.dataSource = this.filteredList
      this.calendarKey+=1
      this.selectedId = null
    },
    getFilterAvailabilities() {
      let arr = []
      if (this.availabilities) {
        arr = _.cloneDeep(this.availabilities.items)
      }
      return arr
    },
    async onChangeFullyBooked(e) {
      this.filteredList = this.getFilterAvailabilities()
      if (this.showWorkCover) {
        this.filteredList = this.filteredList.map(item => {
          const arr = []
          item.Availabilities.forEach(a => {
            const avaArr = []
            if (a.AvailabilityOptions.ShowWorkCover) {
              avaArr.push(a)
            }
            if (avaArr.length > 0) arr.push({...a, Availabilities: avaArr})
          })
          return {
            ...item,
            Availabilities: arr
          }
        })
        this.filteredList = this.filteredList.filter(item => item.Availabilities.length > 0)
      }

      if (e) {
        this.filteredList = this.filteredList.filter(item => item.status !== 'fully booked')
      }
      this.dataSource = this.filteredList
      this.calendarKey+=1
      this.selectedId = null

    },

    initSearchResult() {
      return {
        calendarDate: moment().format('YYYY-MM-DD'),
        availabilities: [],
        dataSourceAvailabilities: [],
        specialists: [],
        numberTimeSlotsBooked: 0,
        numberTimeSlots: 0,
        summary: '',
        results: [],
        searched: false,
      }
    },

    clearSearch() {
      this.searchOption = {
        deliveryMethod: null,
        specialtyId: '',
        specialistId: '',
        locationId: '',
        locationName: '',
        regionId: null,
        radius: '',
        startDate: window.moment().format('YYYY-MM-DD'),
        endDate: window.moment().add(6, 'w').format('YYYY-MM-DD'),
        bookingTypeID: null,
        StateID: null
      }
    },

    getInitials(specialist) {
      var initials = ""
      if (specialist.FirstName) {
        initials = specialist.FirstName.substring(0, 1)
      }

      if (specialist.Surname) {
        initials = initials + specialist.Surname.substring(0, 1)
      }
      return initials
    },

    tapViewCalendar(specialistId, specialistName) {
      if (this.isBookingWithoutAvailability) {
        this.gotoSearchCase(specialistId)
      } else {
        this.isDisplayOnly = false
        this.isFromSpecialist = true
        this.getSpecialistDetails(specialistId, specialistName)
      }
      this.selectedId = specialistId
    },

    displayDateRange() {
      if (this.searchOption.bookingTypeID !== 8) {
        return utilities.formatDate(this.searchOption.startDate, 'DD/MM/YYYY') + ' - ' + utilities.formatDate(this.searchOption.endDate, 'DD/MM/YYYY')
      }
    },

    showAllSearchLog() {
      this.searchLogs = this.allSearchLog
      $('html, body').animate({
        scrollTop: $(".box-search-history").offset().top - 200
      }, 500);
    },

    async tapBooking(index, type, isBook = false, e) {
      await this.$store.dispatch('loading/setLoadComponent', true)
      var bookingParams = await this.getBookingData(index, type, e)
      await this.$store.dispatch('loading/setLoadComponent', false)
      if (this.isBookingWithoutAvailability) {
        this.gotoSearchCase(bookingParams.id)
      } else {
        var routeData = null
        if (this.user.type >= 3) {  // Admin
          if (bookingParams.caseId) {
            await this.$store.dispatch("booking/setBookingObject", bookingParams)
            this.$router.push({name: 'admin-create-new-booking'}).catch((err) => {
            })
            return
          }
          if (this.bookingRequestId) {
            bookingParams.bookingRequestId = this.bookingRequestId
          }
          await this.$store.dispatch("booking/setBookingObject", bookingParams)
          if (isBook || this.isWaitlisted) {
            if (this.bookingRequestId) {
              routeData = this.$router.resolve({name: 'admin-create-new-booking'})
            } else {
              routeData = this.$router.resolve({name: 'admin-search-cases-details'})
            }
          } else {
            routeData = this.$router.resolve({name: 'admin-search-cases-details'})
          }
        } else {  // Client
          this.$store.dispatch("booking/setBookingObject", bookingParams)
          if (this.isWaitlisted || bookingParams.bookingId || bookingParams.caseId) {
            if (bookingParams.bookingId && bookingParams.caseId) {
              routeData = this.$router.resolve({name: 'manage-booking'})
            } else {
              routeData = this.$router.resolve({name: 'search-cases-details'})
            }
          } else {
            routeData = this.$router.resolve({name: 'search-cases-details'})
          }
        }

        if (routeData != undefined && routeData.href != undefined) window.open(routeData.href, "_self")
      }
    },

    async getBookingData(index, type, e) {
      let canHasFace = true
      if(this.searchResultOption.bookingTypeID === 19) {
        canHasFace = false
      } else {
        canHasFace =  e.Location.City.Region.StateObject.StateID == this.searchResultOption.StateID.replaceAll('s', '') && (!this.searchResultOption.regionId || e.Location.City.Region.RegionID == this.searchResultOption.regionId.replaceAll('r', ''))
        if (this.curInfo) {
          canHasFace = this.curInfo.item.Location.City.Region.StateObject.StateID == this.searchResultOption.StateID.replaceAll('s', '') && (!this.searchResultOption.regionId || this.curInfo.item.Location.City.Region.RegionID == this.searchResultOption.regionId.replaceAll('r', ''))
        }
      }
      var bookingParams = {
        id: this.curInfo ? this.curInfo.item.SpecialistID : e.SpecialistID,
        serviceTypes: e.ServiceTypes.map(item => item.BookingTypeID),
        typeId: this.searchResultOption.bookingTypeID,
        waitlisted: this.isWaitlisted,
        endDate: this.searchResultOption.endDate,
        locationId: this.curInfo ? this.curInfo.item.Location.LocationID : (e.Location?.LocationID || null),
        locationName: this.curInfo ? this.curInfo.item.Location.LocationName : (e.Location?.LocationName || ''),
        bookingDate: this.curInfo ? this.curInfo.item.AvailabilityDate : e.AvailabilityDate,
        bookingTime: this.curInfo ? this.curInfo.item.StartTime : e.StartTime,
        bookingEndTime: this.curInfo ? this.curInfo.item.EndTime : e.EndTime,
        caseId: this.singleCase.CaseID,
        bookingId: this.booking.BookingID,
        availabilityId: this.curInfo ? this.curInfo.item.AvailabilityID : e.AvailabilityID,
        // delivery methods contains virtual
        deliveryMethods: e.DeliveryMethods ? e.DeliveryMethods.map(item => item.DeliveryMethodID).filter(item => {
          if (item === 1 && !canHasFace) {
            return false
          }
          return true
        }) : [],
        regionId: this.searchResultOption.regionId,
        qualificationId: this.searchResultOption.specialtyId,
        isSingleId: !this.isFromCalendar,
        isFromSpecialist: this.isFromSpecialist,
        isSupplementary: false,
      }
      if(this.redReschedule) {
        bookingParams.redReschedule = true
      }
      bookingParams.defaultDeliveryMethod = bookingParams.deliveryMethods.length > 1 ? null : (this.searchResultOption.bookingTypeID === 7 ? 2 : bookingParams.deliveryMethods[0])
      if (this.booking) {
        bookingParams.caseId = this.booking.CaseID
        bookingParams.isNewCase = false
        bookingParams.ClientName = this.booking.Case.Client.ClientName
        bookingParams.ClientContactID = this.booking.ClientContactID
        const clientContacts = await utilities.getClientContacts(this.booking.Case.ClientID)
        bookingParams.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(clientContacts, false))
        if (!bookingParams.defaultDeliveryMethod && bookingParams.deliveryMethods.find(item => item === this.booking.DeliveryMethodID)) {
          bookingParams.defaultDeliveryMethod = this.booking.DeliveryMethodID
        }
      }
      if (this.bookingRequest) {
        bookingParams.claimantFirstName = this.bookingRequest.claimantFirstName
        bookingParams.claimantSurname = this.bookingRequest.claimantSurname
        bookingParams.dateOfBirth = this.bookingRequest.dateOfBirth
        bookingParams.ClientReference = this.bookingRequest.ClientReference
        bookingParams.IncidentState = this.bookingRequest.IncidentState
        const clientContacts = await utilities.getClientContacts(this.bookingRequest.clientId)
        bookingParams.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(clientContacts, false))
        let caseOwner = clientContacts.find(item => item.UserID === this.bookingRequest.submittedBy)
        if(caseOwner) {
          bookingParams.caseOwner = caseOwner.ClientContactID
        }
      }

      //Pass clientId into booking flow when admin try to add booking from Admin clients screen
      if (this.clientId) {
        bookingParams.clientId = this.clientId
      }

      if (bookingParams.waitlisted) {
        bookingParams.bookingTime = this.waitlistTime
      }

      if (this.curInfo) {
        bookingParams.additionId = e.SpecialistID
        bookingParams.additionBookingDate = e.AvailabilityDate
        bookingParams.additionalStartTime = e.StartTime
        bookingParams.additionAvalabilityID = e.AvailabilityID
        bookingParams.additionLocationID = e.Location.LocationID
        bookingParams.additionEndTime = e.EndTime
      }
      return bookingParams
    },

    setSearchItem(item) {
      this.clearSearch()
      this.showCalendar = false
      this.showNoSearchResult = false
      this.showSearchResult = false
      this.showAlternative = false
      this.showRelatedProf = false
      this.showSpecialist = false
      this.showSpecialistAvailable = false

      this.isDateChange = true
      if(item.Certifications && item.Certifications.length > 0) {
        this.searchOption.CertificationIDs = item.Certifications.map(item => item.CertificationID)
      }
      if (item.Qualifications && item.Qualifications.length > 0) {
        this.searchOption.specialtyId = item.Qualifications.map(item => item.QualificationID)
        this.searchOption.specialistId = ''
        this.clickSpecialty = true
        this.clickSpecialist = false
        this.isHideSpecialty = false
      } else {
        this.clickSpecialist = true
        this.clickSpecialty = false
        this.isHideSpecialty = true
        this.searchOption.specialistId = item.SpecialistID
        this.searchOption.specialtyId = []
      }
      if (item.BookingType) {
        this.searchOption.bookingTypeID = item.BookingTypeID
        this.onChangeBookingType()
      }
      if (item.DeliveryMethods && item.DeliveryMethods.length > 0) {
        this.searchOption.deliveryMethod = item.DeliveryMethods.map(item => item.DeliveryMethodID)
      }
      if (item.State) {
        this.locationValue = []
        this.searchOption.StateID = 's' + item.State.StateID
        this.locationValue.push(this.searchOption.StateID)
        if (item.Region) {
          this.searchOption.regionId = 'r' + item.Region.RegionID
          this.locationValue.push(this.searchOption.regionId)
        }
      }
      this.searchOption.startDate = this.validateDate(item.StartDate)
      this.searchOption.endDate = this.validateDate(item.EndDate)
      this.clickBookingType = true
      $('html, body').animate({
        scrollTop: $(".search-details").offset().top - 200
      }, 500);
    },

    validateDate(selactedDate) {
      var date = moment().format("YYYY-MM-DD")
      if (moment(selactedDate).isSameOrAfter(date)) {
        return selactedDate
      } else {
        return date
      }
    },

    changeRegion(item) {

      if (item && item.length > 0) {
        this.searchOption.StateID = item[0]
        this.searchOption.regionId = null
        if (item.length > 1) {
          this.searchOption.regionId = item[1]
        }
      } else {
        this.searchOption.regionId = null;
        this.searchOption.StateID = null
      }
    },

    getNeedAvailability(v) {
      return utilities.bookingTypeWithAvailability(v)
    },

    //
    async gotoSearchCase(specialistId) {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const sp = await utilities.getSpecialistById(specialistId)
      const filter = sp.PerformedServices.find(item => item.BookingTypeID === this.searchOption.bookingTypeID)
      if(!filter) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-warning">' +
              '            <b>Error:</b> This doctor does not perform that service type. If required, update the Services Performed for this doctor on their profile, and start the booking again.' +
              '          </div>',
        });
        await this.$store.dispatch('loading/setLoadComponent', false)
        return
      }
      if(this.user.type >= 3) {
        await this.$store.dispatch('loading/setLoadComponent', true)
        const result = await utilities.getRedAlerts({SpecialistID: specialistId})
        await this.$store.dispatch('loading/setLoadComponent', false)
        if (result && result.length > 0) {
          this.$alert(result[0].Note, 'Specialist Red Alert', {
            confirmButtonText: 'OK',
            callback: () => {
              this.toCasePage(specialistId)
            }
          })
        } else {
          this.toCasePage(specialistId)
        }
      } else {
        this.toCasePage(specialistId)
      }
    },

    toCasePage(specialistId) {
      var bookingTypeId = this.searchOption.bookingTypeID
      this.specialist = this.specialists.find((x) => x.id == specialistId)
      var bookingParams = {
        id: this.specialist.id,
        typeId: bookingTypeId,
        waitlisted: this.isWaitlisted ? true : false,
        endDate: this.searchOption.endDate,
        fillOrder: this.specialist.fillOrder,
        locationId: this.specialist.locationId,
        bookingDate: "",
        bookingTime: "",
        caseId: "",
        bookingId: "",
        availabilityId: "",
        requiresTravel: this.specialist.requiresTravel,
        videoLinkAvailable: this.specialist.videoLinkAvailable,
        regionId: this.searchOption.regionId,
        qualificationId: this.searchOption.specialtyId,
        isSingleId: this.isFromCalendar ? false : true,
        isFromSpecialist: this.isFromSpecialist,
        isSupplementary: this.searchOption.bookingTypeID === 8,
        serviceTypes: this.bookingTypes.filter(item => !utilities.bookingTypeWithAvailability(item.id)).map(item => item.id)
      }
      this.$store.dispatch("booking/setBookingObject", bookingParams)
      var routeData = this.$router.resolve({name: 'admin-search-cases-details'})
      if (routeData != undefined && routeData.href != undefined) window.open(routeData.href, "_blank")
    },

    async tapSearchAlternative() {
      await this.tapSearch('alternative')
    },
    async tapSearchRelated() {
      await this.tapSearch('related')
    },

    async tapSearch(v) {

      if (!this.validateBookingType || !this.validateServiceType || !this.validateLocation || !this.validateDateRange || !this.validateSpecialty || !this.validateSpecialist || this.invalidDate) {
        this.hasError = true
        return
      }
      this.hasError = false

      if (!utilities.bookingTypeWithAvailability(this.searchOption.bookingTypeID)) {
        //Without selecting a availability and the time, go to the search case screen

        if (this.searchOption.specialistId) {
          this.isBookingWithoutAvailability = false
          this.gotoSearchCase(this.searchOption.specialistId)
          return
        } else {
          this.isBookingWithoutAvailability = true
        }
      }

      this.isBookingWithoutAvailability = false
      await this.$store.dispatch('loading/setLoadComponent', true)
      this.searchResult.results = []
      if (this.searchOption.specialistId) {
        this.showCurrentMonth()
      }

      var params = {
        BookingTypeID: this.searchOption.bookingTypeID,
        QualificationIDs: this.searchOption.specialtyId && this.searchOption.specialtyId.length > 0 ? this.searchOption.specialtyId.join(',') : null,
        SpecialistID: this.searchOption.specialistId || null,
        DeliveryMethodIDs: this.searchOption.deliveryMethod && this.searchOption.deliveryMethod.length > 0 ? this.searchOption.deliveryMethod.join(',') : null,
        StartDate: this.searchOption.startDate,
        EndDate: this.searchOption.endDate,
        CertificationIDs: this.searchOption.CertificationIDs && this.searchOption.CertificationIDs.length > 0 ? this.searchOption.CertificationIDs.join(',') : null,
      }

      if (params.BookingTypeID === 19) {
        params.StartDate = window.moment().format('YYYY-MM-DD')
        params.EndDate = window.moment().add(30, 'day').format('YYYY-MM-DD')
        utilities.getTPDPopUp().then(res => {
          this.tpdList = res
          console.log(res)
        })
      }

      params.StartDate = this.validateDate(params.StartDate)
      params.EndDate = this.validateDate(params.EndDate)

      // Supplementary
      if (this.searchOption.bookingTypeID === 8) {
        var specialist = this.specialists.find((x) => x.id == this.searchOption.specialistId)
        var city = specialist.locations.find((x) => x.id == specialist.practiceLocationId).cityName
        for (var i = 0; i < this.regionLocations.length; i++) {
          var item = this.regionLocations[i].children.find((x) => x.label.toUpperCase() == city.toUpperCase())
          if (item != null) {
            this.searchOption.regionId = item.id
            break
          }
        }
        if (this.searchOption.regionId == null || this.searchOption.regionId == "") {
          this.searchOption.regionId = "c1"
        }
      }

      this.searchOption.startDate = params.StartDate
      this.searchOption.endDate = params.EndDate

      if (this.searchOption.regionId != null && this.searchOption.regionId !== 'r') {
        if (this.searchOption.regionId && this.searchOption.regionId.includes('r')) params.RegionID = this.searchOption.regionId.replace('r', '')
      }

      if (this.searchOption.StateID != null) {
        if (this.searchOption.StateID.includes('s')) params.StateID = this.searchOption.StateID.replace('s', '')
      }

      await this.$store.dispatch("booking/setBookingObject", '')
      if (v && v === 'related') {
        this.availabilities = await utilities.searchRelatedAvailability(params, params.StateID, params.RegionID)
        this.availabilities.type = 'related'
      } else if (v && v === 'alternative') {
        this.availabilities = await utilities.searchAlternativeAvailability(params, params.StateID, params.RegionID)
        this.availabilities.type = 'alternative'
      } else {
        this.availabilities = await utilities.getSearchSpecialistByAvailabilityNew(params, params.StateID, params.RegionID)
        this.availabilities.type = 'specialist'
      }

      if(params.BookingTypeID === 17) {
        const deepCopy = _.cloneDeep(params)
        delete deepCopy.SpecialistID
        deepCopy.QualificationIDs = 31 // Occupational Therapist
        this.additionalAvailabilities = await utilities.getSearchSpecialistByAvailabilityNew(deepCopy, deepCopy.StateID, deepCopy.RegionID)
        this.additionalAvailabilities.type = 'specialist'
        if(this.additionalAvailabilities) {
          setTimeout(() => {
            this.$refs.clientHorizontalCalendar2.myIndex = 2
            this.$refs.clientHorizontalCalendar.myIndex = 1
            this.$forceUpdate()
          }, 100)
        }
      } else {
        this.additionalAvailabilities = {}
      }


      this.searchResultOption = _.cloneDeep(this.searchOption)
      this.availabilities.type = 'specialist'
      this.filterMode = false
      this.showSearchResult = true
      this.noFaceToFaceMsg = null
      this.selectedId = null
      if (this.availabilities && this.availabilities.items.length > 0) {
        this.showCalendar = true
        this.showNoSearchResult = false
        this.dataSource = this.availabilities.items
      } else {
        this.showCalendar = false
        this.showNoSearchResult = true
        this.dataSource = []
      }

      this.showOnlyAvailable = true
      this.onChangeFullyBooked(true)
      await this.$store.dispatch('loading/setLoadComponent', false)
      this.getSearchLog()
    },

    showCurrentMonth() {
      var currentMonth = window.moment(this.searchOption.startDate).format('M') - 1
      for (var i = 0; i < currentMonth; i++) {
        setTimeout(() => {
          $('.month-container[data-month-id="' + i + '"]').hide()
        }, 1000)
      }
      for (i = currentMonth + 1; i < 12; i++) {
        setTimeout(() => {
          $('.month-container[data-month-id="' + i + '"]').hide()
        }, 1000)
      }
    },


    tapWaitList(e) {
      this.isWaitlisted = true
      this.isFromCalendar = true
      this.waitlistTime = e.startTime
      this.specialist.locationId = e.location
      this.specialist.bookingDate = moment(e.date).format('YYYY-MM-DD')
      this.specialist.specialistAvailabilityId = e.availabilityId
      if (this.specialist.id == undefined) this.specialist.id = e.specialistId
      this.tapBooking(0, "", false, e)
    },

    tapAvailable(e) {
      if (e.status !== 'fully booked' && item.BookingStatus !== 'A') return
      this.isWaitlisted = false
      this.isFromCalendar = true
      this.specialist.locationId = e.location
      this.specialist.bookingDate = moment(e.date).format('YYYY-MM-DD')
      this.specialist.specialistAvailabilityId = e.availabilityId
      this.tapBooking(0, "", false, e)
    },

    async tapAvailableSlot(e, item) {
      if (e.status !== 'fully booked' && item.BookingStatus !== 'A') return
      if(this.searchResultOption.bookingTypeID === 17) {
        if(this.curInfo && item.myIndex === 2) {
          if(item.AvailabilityID === this.curInfo.item.AvailabilityID) {
            return
          }
          let result = null
          await this.$store.dispatch('loading/setLoadComponent', true)
          if(this.user.type >= 3) {
            result = await utilities.getRedAlerts({SpecialistID: e.specialistId})
          }
          await this.$store.dispatch('loading/setLoadComponent', false)
          if (result && result.length > 0) {
            this.$alert(result[0].Note, 'Specialist Red Alert', {
              confirmButtonText: 'OK',
              callback: () => {
                this.specialist.id = this.curInfo.e.specialistId
                this.specialist.bookingDate = window.moment(this.curInfo.e.date).format('YYYY-MM-DD')
                this.specialist.bookingTime = this.curInfo.item.StartTime
                this.specialist.specialistAvailabilityId = this.curInfo.item.AvailabilityID

                this.tapBooking(0, "", false, item)
              }
            })
          } else {
            this.specialist.id = this.curInfo.e.specialistId
            this.specialist.bookingDate = window.moment(this.curInfo.e.date).format('YYYY-MM-DD')
            this.specialist.bookingTime = this.curInfo.item.StartTime
            this.specialist.specialistAvailabilityId = this.curInfo.item.AvailabilityID

            this.tapBooking(0, "", false, item)
          }
        } else {

          if(!this.curInfo && item.myIndex !== 1) {
            this.$alert('Please select the availability on top calendar first!', 'Error', {
              confirmButtonText: 'OK',
              type: 'error'
            })
            return
          }
          this.curInfo = {e, item}
          let result = null
          if(this.user.type >= 3) {
            await this.$store.dispatch('loading/setLoadComponent', true)
            result = await utilities.getRedAlerts({SpecialistID: e.specialistId})
            await this.$store.dispatch('loading/setLoadComponent', false)
            if (result && result.length > 0) {
              this.$alert(result[0].Note, 'Specialist Red Alert', {
                confirmButtonText: 'OK',
                callback: () => {
                  this.$alert('Please select the Occupational Therapist availability for the IME Plus booking', 'IME Booking Warning', {
                    confirmButtonText: 'OK',
                    callback: () => {
                      this.isWaitlisted = false
                      if (e.status === 'fully booked') {
                        this.isWaitlisted = true
                        this.waitlistTime = item.StartTime
                      }
                      this.$forceUpdate()
                    }
                  });
                }
              })
            } else {
              this.$alert('Please select the Occupational Therapist availability for the IME Plus booking', 'IME Booking Warning', {
                confirmButtonText: 'OK',
                callback: () => {
                  this.isWaitlisted = false
                  if (e.status === 'fully booked') {
                    this.isWaitlisted = true
                    this.waitlistTime = item.StartTime
                  }
                  this.$forceUpdate()
                }
              });
            }
          }
        }
        return
      }
      this.curInfo = null
      await this.$store.dispatch('loading/setLoadComponent', true)
      let result = null
      if(this.user.type >= 3) {
        result = await utilities.getRedAlerts({SpecialistID: e.specialistId})
      }
      await this.$store.dispatch('loading/setLoadComponent', false)
      if (result && result.length > 0) {
        this.$alert(result[0].Note, 'Specialist Red Alert', {
          confirmButtonText: 'OK',
          callback: () => {
            this.isWaitlisted = false
            if (e.status !== 'fully booked' && item.BookingStatus !== 'A') return
            if (e.status === 'fully booked') {
              this.isWaitlisted = true
              this.waitlistTime = item.StartTime
            }

            this.specialist.id = e.specialistId
            this.specialist.bookingDate = moment(e.date).format('YYYY-MM-DD')
            this.specialist.bookingTime = item.StartTime
            this.specialist.specialistAvailabilityId = item.AvailabilityID
            this.tapBooking(0, "", false, item)
          }
        });
      } else {
        this.isWaitlisted = false
        if (e.status !== 'fully booked' && item.BookingStatus !== 'A') return
        if (e.status === 'fully booked') {
          this.isWaitlisted = true
          this.waitlistTime = item.StartTime
        }

        this.specialist.id = e.specialistId
        this.specialist.bookingDate = window.moment(e.date).format('YYYY-MM-DD')
        this.specialist.bookingTime = item.StartTime
        this.specialist.specialistAvailabilityId = item.AvailabilityID
        this.tapBooking(0, "", false, item)
      }
    },


    //get Year calender Data by SpecialistID. When user click View Calander
    async getSpecialistDetails(specialistId = -1, specialistName = "") {
      var params = {}
      if (specialistId != -1) {
        let viewSpecialist
        viewSpecialist = _.cloneDeep(this.filteredList.filter(item => item.specialistId === specialistId))
        if (viewSpecialist && viewSpecialist.length > 0) {
          this.showSearchResult = true
          this.dataSource = viewSpecialist
          this.specialist = this.availabilities.specialist.find(item => item.specialists.SpecialistID === specialistId)?.specialists
          this.calendarKey += 1
          return
        } else {
          this.$store.dispatch('loading/setLoadComponent', true)
          var items = []
          items = this.spLocations.filter((x) => x.specialistId == specialistId)
          var locationIds = '0'
          if (items && !this.searchOption.videoLink) {
            items.map((i) => {
              if (locationIds == '0') {
                locationIds = i.locationId.toString()
              } else {
                if (!locationIds.includes(i.locationId)) {
                  locationIds = locationIds + ',' + locationIds
                }
              }
            })
          }
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      } else {
        this.$store.dispatch('loading/setLoadComponent', true)
        params = {
          SpecialistID: specialistId,
          StartDate: moment(this.searchOption.startDate).format('YYYY-MM-DD'),
          EndDate: moment(this.searchOption.startDate).add(12, 'M').format('YYYY-MM-DD'),
          LocationID: 0,
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      }

      if (specialistId == -1) {
        // supplymentry
        if (this.searchOption.bookingTypeID === 8) {
          this.showSpecialist = true
        }
      }

      this.calendarKey += 1
      if (specialistId != -1) {
        this.$store.dispatch('loading/setLoadComponent', false)
      }
    },

    getSearchOption(specialtyId, specialistId) {
      let value = ''
      if (this.specialties.length > 0) {
        if (specialtyId != undefined && specialtyId != '') {
          value = this.specialties.filter((x) => specialtyId.includes(x.id))
          value = value.map(item => item.name).join(', ')
        } else if (specialistId != undefined && specialistId != '') {
          value = this.specialists.find((x) => x.id == specialistId).fullName
        }
      }
      return value
    },

    formatDate(dateOfBirth) {
      return utilities.formatDate(dateOfBirth, 'DD/MM/YYYY')
    },

    getYear() {
      return moment().format('YYYY')
    },

    getClaimantTypeName(id) {
      var type = ''
      if (id && this.claimTypes.length > 0) {
        type = this.claimTypes.find((x) => x.id == id).name
      }
      return type
    },

    onChangeSpecialty(v) {
      if (v) {
        this.searchOption.specialistId = ""
      }
    },

    onChangeSpecialist(v) {
      this.searchOption.specialtyId = ""
    },

    onChangeBookingType() {
      if (this.searchOption.bookingTypeID === 8 || this.searchOption.bookingTypeID === 6 || this.searchOption.bookingTypeID === 18 || this.searchOption.bookingTypeID === 16 || this.searchOption.bookingTypeID === 19 || this.searchOption.bookingTypeID === 21) {
        this.hideOther = true
      } else {
        this.hideOther = false
      }
      this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.searchOption.bookingTypeID)
    },

    handleClickBookingType() {
      this.clickBookingType = true
    },

    handleClickSpecialty() {
      this.clickSpecialty = true
      // this.clickSpecialist = false
      // this.searchOption.specialistId = ''
    },

    handleClickSpecialist() {
      this.clickSpecialist = true
      // this.clickSpecialty = false
      // this.searchOption.specialtyId = ''
    },

    changeDateRange(item) {
      var startDate = utilities.formatDate(item[0])
      var endDate = utilities.formatDate(item[1])
      var todayDate = moment().format('YYYY-MM-DD')
      this.invalidDate = false
      if (moment(endDate).isBefore(todayDate)) {
        this.invalidDate = true
      } else {
        this.isDateChange = true
        this.searchOption.startDate = startDate
        this.searchOption.endDate = endDate
      }
    },

    async tapReadMore(index) {
      let viewSpecialist
      viewSpecialist = _.cloneDeep(this.availabilities.items.filter(item => item.specialistId === index && window.moment(item.date).isBefore(window.moment().add(3, 'day'))))

      this.$refs.profileReadMoreModal.availabilities = viewSpecialist
      await this.$refs.profileReadMoreModal.loadData(index)
      this.$refs.profileReadMoreModal.handleModal()
    },

    tapSubmitRequest(specialistId = undefined) {
      if (this.user.type >= 3) {
        this.$store.dispatch('bookingRequest/setBookingRequestObject', this.searchResultOption)
        this.$router.push({path: '/admin-manage-booking-request', query: {spId: specialistId}}).catch((err) => {
        })
      } else {
        if (this.showCaseInfo) {
          this.$router.push({
            path: '/booking-request',
            query: {id: this.singleCase.CaseID, spId: specialistId}
          }).catch((err) => {
          })
        } else {
          if (specialistId) {
            this.$router.push({path: '/booking-request', query: {spId: specialistId}}).catch((err) => {
            })
          } else {
            this.$router.push({path: '/booking-request', query: {isEmpty: true}}).catch((err) => {
            })
          }
        }
      }
    },

    setSearchInfo() {
      this.clickBookingType = true
      this.clickSpecialist = true
      if (this.redReschedule) {
        this.specialties = this.booking.Specialist.Qualifications.map(item => {return {id: item.QualificationID, name: item.QualificationName}})
        this.listSpecialists = [{id: this.booking.Specialist.SpecialistID, name: utilities.getSpecialistFullNameUpper(this.booking.Specialist)}]
      }
      if (this.bookingTypeId) {
        this.searchOption.bookingTypeID = this.bookingTypeId
      }

      if (this.booking.BookingID) {
        this.searchOption.specialistId = this.booking.SpecialistID
        this.searchOption.bookingTypeID = this.booking.BookingType.BookingTypeID
        this.onChangeBookingType()
        this.searchOption.deliveryMethod = [this.booking.DeliveryMethodID]
      }

      var location = this.locations.find((x) => x.id === this.booking.LocationID)
      if (location !== undefined) {
        var state = 's' + location.stateId
        var region = 'r' + location.regionId
        if (location.stateId) {
          this.locationValue = []
          this.searchOption.StateID = state
          this.locationValue.push(this.searchOption.StateID)
          if (location.regionId) {
            this.searchOption.regionId = region
            this.locationValue.push(this.searchOption.regionId)
          }
        }
      }

      // Set search of related service
      if (this.specialty) {
        this.searchOption.specialtyId = this.specialty
        this.searchOption.specialistId = ''
        this.clickSpecialty = true
        this.clickSpecialist = false
        this.booking.BookingID = ''
      } else {
        // this.searchOption.startDate = utilities.formatDate(this.booking.bookingDateTime)
        // this.searchOption.endDate = utilities.formatDate(this.booking.bookingDateTime)
      }
    },

    async getSearchLog() {
      var params = {
        PageNum: 1,
        PageSize: 20,
      }
      this.allSearchLog = []
      this.searchLogs = []
      utilities.getSearchLogsNew(params, this.user.type).then(r => {
        this.allSearchLog = r
        let length = this.allSearchLog.length >= 5 ? 5 : this.allSearchLog.length
        for (let i = 0; i < length; i++) {
          this.searchLogs.push(this.allSearchLog[i])
        }
      })
    },

    getBookingType() {
      const obj = this.allBookingTypes.find(item => Number(item.id) === Number(this.searchResultOption.bookingTypeID))
      if(obj) {
        return obj.name
      }
      return ''
    },

    async loadData() {
      if (this.singleCase.CaseID && !this.booking.BookingID) {
        this.singleCase = await utilities.getCaseByCaseId(this.singleCase.CaseID)
      }
      console.log('-----load-----')
      const apiArr = [utilities.getBookingTypes(), utilities.getSpecialists(), utilities.getQualifications(), utilities.getLocations(), utilities.getCertificationsChoice()]
      if (this.booking.BookingID) {
        apiArr.push(utilities.getEditBookingById(this.booking.BookingID))
      }
      const r = await Promise.all(apiArr)
      console.log('-----r-----')
      await this.getSearchLog()
      console.log('----------')
      if (this.user.type < 3) {
        this.allBookingTypes = r[0].filter(item => item.settings.Client.AllowBooking)
      } else {
        this.allBookingTypes = r[0]
      }

      this.filteredBookingTypes = this.allBookingTypes
      let specialists = r[1]
      specialists = specialists.filter(item => item.specialistStatus)
      this.certifications = r[4];
      this.specialists = specialists
      this.originalListSpecialists = _.cloneDeep(utilities.getDropdownSpecialist(this.specialists))
      this.listSpecialists = this.originalListSpecialists
      console.log(r[2])
      this.specialties = r[2]
      console.log(this.specialties)
      //Ticket #5425 - To improved the page load, saved regionLocations object into the local store.
      // this.regions = await utilities.getRegions()
      this.locations = r[3]
      // this.regionLocations = utilities.getRegionLocations(this.regions, this.locations, isclient)
      this.regionLocations = this.$store.getters["location/getLocationData"]
      if (!this.regionLocations) {
        let regions = await utilities.getRegions()
        let locations = await utilities.getLocations()
        this.regionLocations = utilities.getRegionLocations(regions, locations, true)
      }

      if (this.booking.BookingID) {
        this.booking = r[5]
        this.clientId = this.booking.Case?.ClientID
        this.singleCase = this.booking.Case
        if (this.booking == undefined) {
          this.showContent = false
          return
        }
        this.setSearchInfo()
      } else if (this.searchOption.specialistId != '') {
        this.clickSpecialist = true
      }
    },

    async setBookingRequest() {
      var bookingRequest = await utilities.getBookingRequestById(this.bookingRequestId)
      this.clientId = bookingRequest.clientId
      this.bookingRequest = bookingRequest
      this.disabledBookingType = false
      if (bookingRequest.bookingTypeId) {
        this.searchOption.bookingTypeID = bookingRequest.bookingTypeId
      }
      var regionId = bookingRequest.regionId ? 'r' + bookingRequest.regionId : null
      const stateId = bookingRequest.stateId ? 's' + bookingRequest.stateId : null
      if(stateId) {
        this.locationValue = []
        this.locationValue.push( stateId)
        this.searchOption.StateID = stateId
        if(regionId) {
          this.locationValue.push(regionId)
          this.searchOption.regionId = regionId
        }
      }

      if (bookingRequest.dateFrom) {
        this.searchOption.startDate = utilities.formatDate(bookingRequest.dateFrom)
      }

      if (bookingRequest.dateTo) {
        this.searchOption.endDate = utilities.formatDate(bookingRequest.dateTo)
      }
      if(bookingRequest.DeliveryMethodIDs.length > 0) {
        this.onChangeBookingType()
        this.searchOption.deliveryMethod = bookingRequest.DeliveryMethodIDs.map(item =>item.DeliveryMethodID)
      } else {
        this.onChangeBookingType()
      }
      if (!bookingRequest.specialistId) {
        if(bookingRequest.qualificationList && bookingRequest.qualificationList.length > 0) {
          this.isHideSpecialty = false
          var item = this.specialties.find((x) => x.name === bookingRequest.qualificationList)
          this.searchOption.specialtyId = item.id
        }
      } else {
        var specialist = this.listSpecialists.find((x) => x.id === bookingRequest.specialistId)
        if (specialist) {
          this.isHideSpecialty = true
          this.searchOption.specialistId = bookingRequest.specialistId
        } else {
          this.isHideSpecialty = false
          this.searchOption.specialistId = ''
        }
      }

      if (this.searchOption.bookingTypeID === 8) {
        this.isHideSpecialty = true
      }

      if (this.searchOption.bookingTypeID === 6) {
        this.showAll = false
        this.showDateRange = true
      } else {
        this.showAll = true
        this.showDateRange = true
      }

      if (this.searchOption.bookingTypeID === 6 || this.searchOption.bookingTypeID === 8) {
        this.showAll = false
        this.showDateRange = false
      }
    },
  },

  async beforeMount() {
    await this.$store.dispatch('loading/setLoadComponent', true)
    this.singleCase.CaseID = this.$route.query.id ? this.$route.query.id : ''
    this.searchOption.specialistId = this.$route.query.specialistId ? this.$route.query.specialistId : ''
    this.clientId = this.$route.query.clientId ? this.$route.query.clientId : ''

    // Get query for search of related service
    this.booking.BookingID = this.$route.query.bookingId ? this.$route.query.bookingId : ''
    if (this.$route.query.rescheduleId) {
      this.booking.BookingID = this.$route.query.rescheduleId
      this.redReschedule = true
    }
    this.specialty = this.$route.query.specialty ? [Number(this.$route.query.specialty)] : ''
    this.bookingTypeId = this.$route.query.bookingTypeId ? Number(this.$route.query.bookingTypeId) : ''

    await this.loadData()

    if (this.singleCase.CaseID) {
      this.showCaseInfo = true
    } else {
      this.showCaseInfo = false
    }
    this.bookingRequestId = this.$route.query.requestId ? this.$route.query.requestId : ''
    if (this.bookingRequestId) {
      await this.setBookingRequest()
    }
    this.searchOption.specialtyId = this.specialty ? this.specialty : ''
    if (this.searchOption.specialistId) {
      this.isHideSpecialty = true
    }
    await this.$store.dispatch('loading/setLoadComponent', false)
    this.showCurrentMonth()

    //hide radius drop down when client is login
    if (this.user.type < 3) {
      this.showRadius = false
    }
  },

  mounted() {
    this.$store.dispatch('booking/setBookingObject', null)
    window.scrollTo({top: 0, behavior: 'smooth'})
  },
}
</script>
<style>
.el-cascader-panel {
  .el-radio {
    margin-bottom: 0;
  }
}
.el-input__inner {
  color: #333 !important;
}
.search-popup-longer .el-select-dropdown__wrap {
  max-height: 290px;
}
</style>
